module.exports = __webpack_public_path__ + "static/media/whitespace.ec8828c1.webp";